export default "/images/vendor/flag-icon-css/flags/4x3/aq.svg?e3fbc5d0ce77f1c9e808345d2bdd18ca";